import * as Sentry from "@sentry/react";

const LENDING_DSN =
  "https://a0adbc442249223bb3b7a223f3776db2@o61203.ingest.us.sentry.io/4509090923413504";
const INTERNAL_NAME = import.meta.env.VITE_PUBLIC_INTERNAL_NAME as string | undefined;
const RELEASE_VERSION = import.meta.env.VITE_BANKING_RELEASE_VERSION as string | undefined;
const isSentryEnabled = Boolean(INTERNAL_NAME);

if (isSentryEnabled) {
  const sentryConfig = {
    dsn: LENDING_DSN,
    environment: INTERNAL_NAME,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.httpClientIntegration(),
      Sentry.replayIntegration({
        block: [".sentry-block"],
        maskAllInputs: true,
        maskAllText: false,
        mask: [".sentry-mask"],
      }),
    ],
    replaysOnErrorSampleRate: 1.0,
    replaysSessionSampleRate: 1.0,
    release: RELEASE_VERSION ?? "Unknown release",
    sendDefaultPii: true,
    tracesSampleRate: 0.25,
  };

  Sentry.init(sentryConfig);
  Sentry.setTag("application", "lending");
}
